/* WERALIS — главная, редакция 2026-09-18 (артефакт W2SEgvjZcaDc9nZXqn7qxD, Version 6).

   Из макета перенесено только то, под чем есть разметка:
     · галерея герой-товара (.pd .thumbs);
     · выбор этапа вечера наведением, фокусом и курсором (#winddown .mom).

   НЕ перенесено, и почему:
     · виджет «Было/Стало» — служебный, на витрине ему нечего делать;
     · windInit со шкалой .scrub — шкала снята из разметки по слову IB 17.09;
     · затемнение героя .dimmer и фильтр гидов .gtab — их элементов в принятой
       редакции нет, код без разметки только притворялся бы работающим. */
(function () {
  'use strict';

  /* ---- галерея герой-товара ---- */
  function gallery() {
    var stage = document.getElementById('pdstage');
    var img = document.getElementById('pdimg');
    var cap = document.getElementById('pdcap');
    if (!stage || !img || !cap) return;
    var buttons = [].slice.call(document.querySelectorAll('.pd .thumbs button'));
    buttons.forEach(function (bt) {
      bt.addEventListener('click', function () {
        buttons.forEach(function (o) { o.setAttribute('aria-pressed', String(o === bt)); });
        img.src = bt.dataset.src;
        img.style.objectPosition = bt.dataset.pos || '';
        img.className = bt.dataset.kind === 'cut' ? 'cut' : '';
        img.alt = bt.getAttribute('aria-label') || '';
        cap.textContent = bt.dataset.cap || '';
        stage.dataset.kind = bt.dataset.kind || 'photo';
      });
    });
  }

  /* ---- вечер: этап следует за человеком ---- */
  function evening() {
    var sec = document.getElementById('winddown');
    if (!sec) return;
    var moms = [].slice.call(sec.querySelectorAll('.mom'));
    if (!moms.length) return;

    function go(n) { sec.dataset.i = String((n + moms.length) % moms.length); }

    moms.forEach(function (m, n) {
      /* Клик оставляет совет открытым: на тач-экране наведения нет. */
      m.addEventListener('click', function () { m.classList.toggle('open'); });
      m.addEventListener('mouseenter', function () { go(n); });
      m.addEventListener('focus', function () { go(n); });
    });

    /* Светило идёт за курсором по всей ширине блока, а не только по строке:
       берётся ближайший по вертикали шаг. На тач-экранах не включается. */
    if (window.matchMedia && window.matchMedia('(pointer:coarse)').matches) return;
    var raf = 0, last = -1;
    function pick(y) {
      var best = 0, bd = Infinity;
      moms.forEach(function (m, n) {
        var r = m.getBoundingClientRect();
        var d = Math.abs(y - (r.top + r.height / 2));
        if (d < bd) { bd = d; best = n; }
      });
      if (best !== last) { last = best; sec.dataset.i = String(best); }
    }
    sec.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch' || raf) return;
      var y = e.clientY;
      raf = requestAnimationFrame(function () { raf = 0; pick(y); });
    });
  }

  function init() { gallery(); evening(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
